

export function getNiceCoins(rate) {
    const steps = [1, 10, 100, 1000, 10000, 100000, 1000000];
    const pricePerCoin = 1 / rate;

    if (!rate || rate <= 0 || !Number.isFinite(pricePerCoin)) {
        return {
            coins: 1,
            usd: '0.00'
        };
    }

    for (let step of steps) {
        if (step * pricePerCoin >= 1) {
            let stepOut = step;
            switch (step) {
                case 1000:
                    stepOut = '1K';
                    break;

                case 10000:
                    stepOut = '10K';
                    break;

                case 100000:
                    stepOut = '100K';
                    break;
                case 1000000:
                    stepOut = '1M';
                    break;
            }

            return {
                coins: stepOut,
                usd: (step * pricePerCoin).toFixed(2)
            };
        }
    }

    return {
        coins: '1M',
        usd: (1000000 * pricePerCoin).toFixed(2)
    };
}